module.exports = __webpack_public_path__ + "img/check-confirmation.d6edf99c.svg";